import { APP_ID, enableProdMode, importProvidersFrom } from '@angular/core';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';


import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { AuthorizeInterceptor } from './app/api-authorization/authorize.interceptor';
import { UserService } from './app/common/services/user.service';
import { MainService } from './app/common/ui/services/main.service';
import { MainNavService } from './app/common/ui/services/main-nav.service';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { ReCaptchaService } from './app/common/services/recaptcha.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppComponent } from './app/app.component';
import { DropdownService } from './app/common/services/dropdown.service';
import { AuthService } from './app/common/services/auth.service';
import { LoggingService } from './app/common/services/logging.service';
import { AgGridModule } from 'ag-grid-angular';
import { provideRouter } from '@angular/router';
import { ROUTES } from './routes.model';
import { DatePipe } from '@angular/common';
import { NgxMaskConfig, provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { AGGridHelperService } from './app/ag-grid/services/ag-grid-helper-service';
import { IngredientService } from './app/common/services/ingredient.service';

// Register all enterprise features
ModuleRegistry.registerModules([AllEnterpriseModule]);

// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: "legacy" });

//If the key is set in the environment use it, else fall back to last known good key.
if (environment.aggridlicense) {
  LicenseManager.setLicenseKey(environment.aggridlicense);
}
else {
  LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-091106}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Johnson,_Mirmiran_&_Thompson,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{7}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{12}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_March_2026}____[v3]_[01]_MTc3MjY2ODgwMDAwMA==6b9e10dc06f6c5b7dd95ffb551b51191");
}

if (environment.production) {
  enableProdMode();
}

export const maskConfig: Partial<NgxMaskConfig> = {
  showMaskTyped: true,
  clearIfNotMatch: false
};

bootstrapApplication(AppComponent, {
  providers: [
    provideEnvironmentNgxMask(maskConfig),
    provideNgxMask(maskConfig),
    {
      provide: APP_ID,
      useValue: 'ng-cli-universal'
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(ROUTES),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      IconSpriteModule,
      NgxFloatUiModule,
      NgIdleKeepaliveModule.forRoot()
    ),
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthorizeInterceptor,
        multi: true
    },
    DatePipe,
    AuthService,
    LoggingService,
    UserService,
    AGGridHelperService,
    IngredientService,
    DropdownService,
    MainService,
    MainNavService,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    ReCaptchaService,
    AgGridModule,
    provideAnimations()
  ]
})
  .catch(err => console.log(err));
